import { NgClass } from '@angular/common';
import { Component, computed, contentChild, contentChildren, effect, inject, input } from '@angular/core';
import { FormGroupDirective, NgControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputNumber } from 'primeng/inputnumber';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { AbstractControlToFormControlPipe } from '../../../pipes/abstract-control-to-form-control.pipe';
import { IconComponent } from '../../icon/icon.component';
import { IconNameModel } from '../../icon/models/icon-name.model';
import { InputNumberComponent } from '../input-number/input-number.component';
import { ValidationMessageComponent } from '../validation-message/validation-message.component';

@Component({
  selector: 'shared-form-field-wrapper',
  imports: [
    ValidationMessageComponent,
    ReactiveFormsModule,
    AbstractControlToFormControlPipe,
    NgClass,
    SkeletonModule,
    IconComponent,
    TooltipModule,
  ],
  templateUrl: './form-field-wrapper.component.html',
  styleUrls: ['./form-field-wrapper.component.scss'],
  providers: [FormGroupDirective],
})
export class FormFieldWrapperComponent {
  public ngControl = inject(NgControl, { optional: true, self: true });

  readonly label = input<string>();
  readonly labelTooltip = input<string>();
  readonly hideRequiredIcon = input(false);
  readonly contentTooltip = input<string>();
  readonly name = input<string>();
  readonly needsEllipsis = input(false);
  readonly isInline = input(false);
  readonly isLoading = input(false);
  readonly isReadOnly = input(false);
  readonly labelTooltipIcon = input<{
    name: IconNameModel;
    color?: string;
    height?: string;
    width?: string;
  }>();

  private readonly projectedInputNumber = contentChild(InputNumber, { descendants: true });
  private readonly projectedInputNumberComponent = contentChild(InputNumberComponent, { descendants: true });

  readonly inputNumberChild = computed(() => this.projectedInputNumber() ?? this.projectedInputNumberComponent()?.inputNumber());

  private readonly projectedValidationMessages = contentChildren(ValidationMessageComponent, { descendants: true });

  protected readonly Validators = Validators;

  constructor() {
    effect(() => {
      const inputNumber = this.inputNumberChild();

      this.projectedValidationMessages().forEach((validationMessage) => validationMessage.inputNumber.set(inputNumber));
    });

    if (this.ngControl) {
      // trick it into thinking control has a valueAccessor, we don't need it because child has
      this.ngControl.valueAccessor = {
        writeValue(): void {
          // do nothing
        },
        registerOnChange(): void {
          // do nothing
        },
        registerOnTouched(): void {
          // do nothing
        },
      };
    }
  }
}
